import DeleteDialog from '@/components/common/delete-dialog/delete-dialog';
import { composeUri } from '@/utils/compose';
import { MANAGER_PLACES } from '@/utils/CONST';
import { useDelete, useNotify } from 'react-admin';
import { useNavigate, useParams } from 'react-router';

const DeleteManagerPlaceDialog = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [deleteOne, { isLoading }] = useDelete();
    const notify = useNotify();

    const navigateBack = () => {
        navigate(-1);
    };

    const handleDeleteOne = () => {
        deleteOne(
            MANAGER_PLACES,
            {
                id: composeUri(MANAGER_PLACES, id),
            },
            {
                onSuccess: () => {
                    notify('ra.notification.deleted', {
                        type: 'success',
                        messageArgs: {
                            smart_count: 1,
                        },
                    });
                    navigateBack();
                },
                mutationMode: 'optimistic',
            },
        );
    };

    return <DeleteDialog isLoading={isLoading} onClose={navigateBack} onClick={handleDeleteOne} />;
};

export default DeleteManagerPlaceDialog;
